import axios, { AxiosResponse } from 'axios';
import { BotConfig, BotGroupsConfig, ApiResponse } from '../types';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://betclas.net:3005/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export const botApi = {
  // Get all bots
  getBots: async (): Promise<BotConfig[]> => {
    const response = await apiClient.get<ApiResponse<BotConfig[]>>('/bots');
    return response.data.data || [];
  },

  // Get bot configuration
  getBotConfig: async (botName: string): Promise<BotGroupsConfig> => {
    const response = await apiClient.get<ApiResponse<BotGroupsConfig>>(`/bots/${botName}/config`);
    return response.data.data!;
  },

  // Update bot configuration
  updateBotConfig: async (botName: string, config: BotGroupsConfig): Promise<void> => {
    await apiClient.put(`/bots/${botName}/config`, config);
  },

  // Start bot
  startBot: async (botName: string): Promise<string> => {
    const response = await apiClient.post<ApiResponse<string>>(`/bots/${botName}/start`);
    return response.data.data || '';
  },

  // Stop bot
  stopBot: async (botName: string): Promise<string> => {
    const response = await apiClient.post<ApiResponse<string>>(`/bots/${botName}/stop`);
    return response.data.data || '';
  },

  // Restart bot
  restartBot: async (botName: string): Promise<string> => {
    const response = await apiClient.post<ApiResponse<string>>(`/bots/${botName}/restart`);
    return response.data.data || '';
  },

  // Get bot logs
  getBotLogs: async (botName: string, lines: number = 100): Promise<string> => {
    const response = await apiClient.get<ApiResponse<string>>(`/bots/${botName}/logs?lines=${lines}`);
    return response.data.data || '';
  },
};

export default apiClient;
